import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Kalkulacka.css';

const ACCOUNTING_TYPE_PRICES = {
  'u1': { price: 1, name: 'Jednoduché – neplatca DPH' },
  'u2': { price: 1, name: 'Jednoduché – platca DPH' },
  'u3': { price: 1, name: 'Podvojné – neplatca DPH' },
  'u4': { price: 1, name: 'Podvojné – platca DPH' }
};

const Kalkulacka = () => {
  const location = useLocation();
  const prefill = location.state?.prefill || null;

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pinInput, setPinInput] = useState('');
  const [pinError, setPinError] = useState('');
  const [selectedServices, setSelectedServices] = useState([]);
  const [clientInfo, setClientInfo] = useState({
    name: prefill?.company || '',
    date: prefill?.date || new Date().toISOString().split('T')[0]
  });
  const [accountingType, setAccountingType] = useState(prefill?.accountingType || '');
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [savePin, setSavePin] = useState('');
  const [saveNote, setSaveNote] = useState('');

  const handleSaveToEvidence = async () => {
    if (!savePin.trim() || selectedServices.length === 0) {
      alert('Chýba PIN alebo vybrané služby');
      return;
    }

    try {
      const entriesToSave = selectedServices.map(service => ({
        companyName: clientInfo.name,
        date: clientInfo.date,
        description: service.name,
        service: service.categoryName,
        quantity: service.quantity,
        unitPrice: service.customPrice ? service.customPriceValue : service.price,
        total: (service.customPrice ? service.customPriceValue : service.price) * service.quantity,
        note: saveNote,
        invoiced: false,
        createdAt: new Date().toISOString()
      }));

      const response = await fetch('/php/work_tracking_api.php?action=add_entries&pin=' + encodeURIComponent(savePin), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ entries: entriesToSave })
      });
      
      const data = await response.json();
      
      if (data.success) {
        alert('Úspešne pridané do evidencie!');
        setShowSaveDialog(false);
        setSaveNote('');
      } else {
        alert('Chyba: ' + (data.message || 'Nepodarilo sa uložiť'));
      }
    } catch (error) {
      alert('Chyba pripojenia k serveru');
    }
  };

  // ... zvyšok tvojho komponentu (zobrazenie, kalkulácia atď.)
  return (
    <div className="kalkulacka-container">
        {/* Tvoj existujúci UI kód */}
        <button onClick={() => setShowSaveDialog(true)}>Uložiť do evidencie</button>
        {/* ... */}
    </div>
  );
};

export default Kalkulacka;